import { useDropshipping } from '@/components/Dropshipping'
import { useLoginModal } from '@/components/Login'
import { useUserStore } from '@/pinia/user'
import { watchOnce } from '@vueuse/core'

/**
 * 处理首页通过链接自动唤起 Dropshipping 逻辑
 */
export const useHomeDropshipping = () => {
  const route = useRoute()
  const router = useRouter()

  if (route.query.bind == null) return

  const { hasBoundStore, activeIndex, showWooView, onDropshipping } = useDropshipping()
  const user = useUserStore()
  const { open: openLoginModal } = useLoginModal()

  onBeforeMount(() => {
    if (user.isLogged) {
      onDropshippingWithShop()
    } else {
      openLoginModal()
    }
  })

  watchOnce(() => user.isLogged, (val) => {
    if (!val) return

    onDropshippingWithShop()
  })

  const onDropshippingWithShop = () => {
    if (!hasBoundStore.value && route.query.bind === 'woocommerce') {
      activeIndex.value = 1
      showWooView.value = true
    }

    onDropshipping()

    const query = route.query

    const { bind, ...params } = query

    router.replace({
      query: params
    })
  }
}
